import React from 'react';
import * as styles from '../css/subtitle.css';

const Subtitle: React.FC = ({ children }) => (
    <div className={styles.root}>
        {children}
    </div>
);

export default Subtitle;
